import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import { apiClient } from './useApi'

/**
 * Senaste flaggkörningens datum (max created) för aktuell tenant (#47). Cachas hela sessionen —
 * körningsdatumet ändras bara ~1 gång/månad, så alla flagg-vyer delar ett enda anrop.
 *
 * Returnerar månaden runt senaste körningen som datepicker-default, samt `ready` som blir true först
 * när svaret kommit. Vyerna väntar in `ready` innan de hämtar flagg-data → ingen "flash" från
 * nuvarande månad. Saknar tenanten körningar (t.ex. ny kommun) faller vi tillbaka på nuvarande månad.
 */
export const useLatestRunMonth = () => {
  const tenant = localStorage.getItem('tenant_id') ?? ''
  const { data, isLoading } = useQuery(
    ['latest-run', tenant],
    async () => {
      const res = await apiClient.latestRun(tenant)
      return res.data.latestRun ?? null
    },
    { staleTime: Infinity, enabled: !!tenant }
  )
  const base = data ? moment(data) : moment()
  return {
    ready: !tenant || !isLoading,
    from: base.clone().startOf('month').format('YYYY-MM-DD'),
    to: base.clone().endOf('month').format('YYYY-MM-DD'),
  }
}
